import { Input } from '@awazevr/design-system.components.input'
import React from 'react'

interface IProps {
  [propName: string]: unknown
}

export const EmailInputField = ({ ...props }: IProps): JSX.Element => {
  return (
    <Input
      name="emailAddress"
      type="text"
      aria-label="email input"
      placeholder="email@email.com"
      {...props}
    />
  )
}
